import type { EnvironmentProviders} from '@angular/core';
import { makeEnvironmentProviders } from '@angular/core';

import { provideAppConfig } from './config/config.public-api';
import { provideAuth } from './auth/auth.public-api';
import { provideCoreHttp } from './http/http.public-api';
import { provideGlobalErrorHandler } from './error/error.public-api';
import { provideNotifications } from './notifications/notifications.public-api';
import { provideObservability } from './observability/observability.public-api';

/**
 * Bootstrap único de los singletons de `core/`. Se agrega a `appConfig.providers`.
 *
 * ORDEN de inicializadores (importa — se resuelven en secuencia):
 *  1. provideAppConfig     → carga /config.json (todo lo demás depende de él)
 *  2. provideCoreHttp      → HttpClient + cadena de interceptores
 *  3. provideAuth          → OIDC + hidrata la sesión (procesa el callback)
 *  4. provideObservability → arranca el SloBeacon (necesita tenant/user)
 *  5. provideGlobalErrorHandler → red de contención de errores
 *
 * `TenantContextService`, `PermissionService`, `RealtimeConnectionService` y
 * `ToastBusService` son `providedIn: 'root'` → no necesitan registro explícito.
 * El realtime se conecta bajo demanda (`connect()`) desde el shell autenticado.
 *
 * `provideNotifications()` resuelve el port de la bandeja in-app a nivel raíz: la
 * campana del topbar es chrome del shell (no una ruta lazy) y necesita el binding
 * disponible fuera de toda feature.
 */
export function provideCore(): EnvironmentProviders {
  return makeEnvironmentProviders([
    provideAppConfig(),
    provideCoreHttp(),
    provideAuth(),
    provideObservability(),
    provideGlobalErrorHandler(),
    ...provideNotifications(),
  ]);
}
